import axios from 'axios';

axios.defaults.baseURL = 'http://www.szyctdz.com:8000';
axios.defaults.timeout = 5000;
axios.defaults.headers['Content-Type'] = 'application/json; charset=utf-8';
//请求拦截器
axios.interceptors.request.use((config)=>{
    return config;
})

//响应拦截器
axios.interceptors.response.use((res)=>{
    return res.data;
},(error)=>{
    return Promise.reject(new Error('faile'));
})

export default axios;



